<template>
  <!-- Portfolio Grid-->
  <section class="page-section bg-light" id="portfolio">
    <div class="container">
      <div class="text-center">
        <h2 class="section-heading text-uppercase">Shows</h2>
        <h3
          class="section-subheading text-muted"
        >If you can't get enough... here you can enjoy some older broadcasts</h3>
      </div>
      <div class="row" v-if="shows">
        <show-teaser v-for="show in shows.data" :key="show.id" :show="show"></show-teaser>
      </div>
      <div v-if="shows" class="d-flex justify-content-center">
        <button class="btn btn-secondary" v-if="showMoreEnabled" @click="showMore">Show more</button>
      </div>
      <div v-if="$apollo.queries.shows.loading" class="text-center mt-5"><strong>loading ...</strong></div>

      
    </div>
  </section>
</template>

<script>
import gql from "graphql-tag";
import showTeaser from "./showTeaser.vue";

export default {
  name: "shows",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "blackmondayradio.nl - Metal op de radio ! - Shows"

  },
  components: {
    "show-teaser": showTeaser,
  },
  data: function () {
    return {
      page: 1,
      shows: null,
      showMoreEnabled: true,
    };
  },
  methods: {
    showMore: function () {
      this.page++;

      this.$apollo.queries.shows.fetchMore({
        variables: {
          page: this.page,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newShows = fetchMoreResult.shows.data;
          const hasMorePages = fetchMoreResult.shows.paginatorInfo.hasMorePages;
          this.showMoreEnabled = hasMorePages;

          return {
            shows: {
              __typename: previousResult.shows.__typename,
              data: [...previousResult.shows.data, ...newShows],
              hasMorePages,
            },
          };
        },
      });
    },
  },
  apollo: {
    shows: {
      query: gql`
        query shows($page: Int!) {
          shows(
            page: $page
            first: 9
            where: { column: ON_MIXCLOUD, operator: EQ, value: true }
            orderBy: { field: ID, order: DESC }
          ) {
            data {
              id
              title
              djs
              image
              dateTimeBroadcast
              date_on_air
              url_mixcloud
              tracks {
                artist
                track
              }
            }
            paginatorInfo {
              count
              currentPage
              hasMorePages
            }
          }
        }
      `,
      variables: {
        page: 1,
      },
    },
  },
};
</script>